export const extractErrorMessage = (error: any): string => {
  if (error?.response?.data?.message) {
    return error.response.data.message;
  }

  if (
    error?.response?.data?.details &&
    error.response.data.details.length > 0
  ) {
    return error.response.data.details[0];
  }

  if (error?.message) {
    return error.message;
  }

  return 'An error occurred while processing your request.';
};

// API 에러인지 확인하는 유틸리티
export const isApiError = (error: any): boolean => {
  return error?.response?.status !== undefined;
};

// 특정 상태 코드인지 확인하는 유틸리티
export const isStatusCode = (error: any, statusCode: number): boolean => {
  return error?.response?.status === statusCode;
};

// 인증 에러인지 확인하는 유틸리티
export const isAuthError = (error: any): boolean => {
  return isStatusCode(error, 401) || isStatusCode(error, 403);
};
